import { EAssetType } from 'constants/enums';
import { DEFAULT_BACKGROUND_COLOR } from 'views/OfferDesign/OfferDesign.consts';

import { GradientFieldConfig, UploadFieldConfig } from './FormFields.types';

export { PERCENTAGE_LEFT_ICON } from './FormFields.utils';

export const PERCENTAGE_LEFT_ICON_STYLES =
  'text-base-foreground text-p-s absolute left-2 top-1/2 -translate-y-1/2';

export const DEFAULT_BG_COLOR_FIELDS: GradientFieldConfig[] = [
  {
    header: 'Background Color',
    name: 'backgroundColor',
    fallback: { colorOne: DEFAULT_BACKGROUND_COLOR }
  }
];

export const BUTTON_SUFFIX_UPLOAD_FIELDS: UploadFieldConfig[] = [
  {
    title: 'Background Image',
    fieldName: 'backgroundImage',
    forceType: EAssetType.BG_BUNDLE,
    tooltip: 'Upload a background image for the offer card',
    isRequired: true
  },
  {
    title: 'Button Suffix Badge',
    fieldName: 'buttonSuffixBadge',
    forceType: EAssetType.BUTTON_ASSET_SUFFIX,
    tooltip: 'Upload a button suffix badge image or animation'
  }
];
